var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{style:({ 'min-width': _vm.width, 'min-height': _vm.height }),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height},on:{"contextmenu":function($event){$event.preventDefault();}}},[_c('use',{attrs:{"href":`${_vm.src}#root`,"width":_vm.width,"height":_vm.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }